// Función para obtener la provincia a partir de las coordenadas
const getProvinceFromCoordinates = async ({ latitude, longitude }) => {
  try {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/reverse.php?lat=` +
        latitude +
        `&lon=` +
        longitude +
        `&zoom=18&format=jsonv2`
    );
    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }
    const data = await response.json();
    return {
      code: data.address["ISO3166-2-lvl4"],
      province: data.address.state,
      country: data.address.country,
      country_code: data.address.country_code,
    };
  } catch (error) {
    console.error("Error fetching province data:", error);
    return null;
  }
};

// Función para activar una variante
function activateVariant(optionContainer, input) {
  // Eliminar la clase que desactiva la variante
  optionContainer.classList.remove("cs-disabled");
  input.classList.remove("disabled");
  input.removeAttribute("disabled");

  // Si había un span de popup, podemos removerlo
  const notifyMeSpan = optionContainer.querySelector(".text-notifyme");
  if (notifyMeSpan) {
    notifyMeSpan.remove();
  }
}

// Función para desactivar una variante
function deactivateVariant(optionContainer, input) {
  // Agregar la clase que desactiva la variante
  optionContainer.classList.add("cs-disabled");
  input.classList.add("disabled");
  input.setAttribute("disabled", "true");

  // Si no existe el span de popup, lo agregamos
  let notifyMeSpan = optionContainer.querySelector(".text-notifyme");
  if (!notifyMeSpan) {
    notifyMeSpan = document.createElement("span");
    notifyMeSpan.style.cursor = "pointer";
    notifyMeSpan.classList.add("text-notifyme");
    notifyMeSpan.setAttribute("onclick", "openPopUpOutOfStock(this)");
    optionContainer.appendChild(notifyMeSpan);
  }
}

// Indica si un .option-variation corresponde a la opcion de talla (y no a
// otra opcion como el color).
function isSizeOptionContainer(optionContainer) {
  return !!(
    optionContainer &&
    optionContainer.querySelector("label.tallas, label.sizes, label.talla, label.size")
  );
}

// Ficha de producto: actualiza los botones "Añadir" (el submit visible en
// escritorio, el que abre el modal en movil y el del modal) segun el stock
// de tallas en el mercado ya resuelto. Si no queda ninguna talla
// disponible, el boton se desactiva y pasa a "Agotado".
// Solo actua sobre botones que nacieron con data-market-pending (los que el
// Liquid ya renderizo desactivados por otro motivo no se tocan). Una vez
// procesados quedan marcados con data-market-managed, para que una
// resolucion del mercado posterior al timeout de seguridad los vuelva a
// recalcular.
function updateProductAddButtons() {
  const buttons = document.querySelectorAll(
    "button[data-product-open-modal][data-market-pending], button[data-product-open-modal][data-market-managed]"
  );

  buttons.forEach((btn) => {
    const productId = btn.getAttribute("data-product-open-modal");
    btn.removeAttribute("data-market-pending");
    btn.setAttribute("data-market-managed", "");

    // Buscar el selector de tallas de este producto en la ficha.
    const radios = Array.from(document.querySelectorAll("variant-radios")).find(
      (el) => el.id && el.id.split("-").pop() === productId
    );

    let allSoldOut = false;
    if (radios) {
      const sizeInputs = Array.from(radios.querySelectorAll(".option-variation"))
        .filter(isSizeOptionContainer)
        .map((container) => container.querySelector('input[type="radio"]'))
        .filter(Boolean);

      allSoldOut =
        sizeInputs.length > 0 &&
        sizeInputs.every(
          (input) => input.disabled || input.classList.contains("disabled")
        );
    }

    // Los botones que abren el modal de tallas (movil) siguen siendo
    // pulsables aunque todo este agotado: en movil las tallas solo se ven en
    // ese modal y es ahi donde el cliente puede pedir el "Avisame". El modal
    // no deja comprar porque todas sus tallas estan desactivadas.
    const opensSizeModal = (btn.getAttribute("onclick") || "").includes("openSize(");

    const label = btn.querySelector("span");
    if (allSoldOut && !opensSizeModal) {
      btn.classList.add("is-sold-out");
      btn.setAttribute("disabled", "");
      btn.classList.add("disabled");
      if (label) label.textContent = btn.getAttribute("data-sold-out-text") || label.textContent;
    } else {
      // Con stock, o boton que abre el modal de tallas (movil): siempre
      // "Añadir" y pulsable; en el modal cada talla agotada ya muestra
      // su "Avisame".
      btn.classList.remove("is-sold-out");
      btn.removeAttribute("disabled");
      btn.classList.remove("disabled");
      if (label) label.textContent = btn.getAttribute("data-add-text") || label.textContent;
    }
  });
}

// Red de seguridad: si por lo que sea el mercado no llega a resolverse
// (proveedor de IP colgado, error JS...), no dejamos el boton "Añadir"
// bloqueado para siempre: a los 15 s se evalua con el estado que haya.
setTimeout(() => {
  if (!window.sucursalActivaResolved) {
    try {
      updateProductAddButtons();
    } catch (error) {
      console.error("updateProductAddButtons (timeout):", error);
    }
  }
}, 15000);

window.sucursalActiva = "WEB";

// A partir de los datos de Nominatim (provincia/pais), calcula a que
// sucursal/mercado corresponde.
function computeLocationFromProvinceData(data) {
  let location = "WEB";

  if (data?.country_code && data.country_code.toLowerCase() !== "es") {
    // Cliente fuera de España: mercado internacional
    location = "WEB INTERNACIONAL";
  } else if (data?.code) {
    switch (data.code) {
      case "ES-IB":
      case "ES-PM":
        location = "WEB BALEARES";
        break;
      case "ES-CN":
      case "ES-GC":
      case "ES-TF":
        location = "WEB CANARIAS";
        break;
      default:
        location = "WEB";
        break;
    }
  }

  return location;
}

// Convierte un country_code de dos letras en el mercado correspondiente.
function marketFromCountryCode(countryCode) {
  if (!countryCode) return null;
  return countryCode.toLowerCase() === "es" ? "WEB" : "WEB INTERNACIONAL";
}

// La geolocalizacion por IP no distingue Baleares/Canarias de la peninsula
// (los operadores moviles suelen enrutar su trafico como si saliera de la
// peninsula). Sin embargo, Canarias tiene un huso horario distinto
// (Atlantic/Canary, una hora por detras de la peninsula/Baleares todo el
// año), lo que nos da una señal extra, gratuita y sin llamadas de red, para
// al menos detectar ese caso cuando el reloj del dispositivo esta en
// automatico (lo habitual en moviles).
function isCanaryTimezone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone === "Atlantic/Canary";
  } catch (error) {
    return false;
  }
}

// Proveedores de geolocalizacion por IP, en orden de preferencia. Se usa mas
// de uno porque los servicios gratuitos sin API key aplican limites de uso
// por IP publica, y en redes moviles (varios paises, no solo el nuestro)
// muchos usuarios comparten la misma IP de operadora (CGNAT), lo que agota
// ese limite para todos ellos a la vez.
const ipGeolocationProviders = [
  async () => {
    const response = await fetch("https://ipwho.is/?fields=success,country_code");
    if (!response.ok) throw new Error(`ipwho.is: ${response.status}`);
    const data = await response.json();
    if (!data.success || !data.country_code) throw new Error("ipwho.is: sin country_code");
    return data.country_code;
  },
  async () => {
    const response = await fetch("https://get.geojs.io/v1/ip/country.json");
    if (!response.ok) throw new Error(`geojs.io: ${response.status}`);
    const data = await response.json();
    // geojs.io devuelve el codigo de 2 letras en "country" (p.ej. "ES"), no
    // en "country_code" (eso es un campo de otros proveedores como ipwho.is).
    if (!data.country) throw new Error("geojs.io: sin country");
    return data.country;
  },
];

// Fallback por geolocalizacion IP (sin permiso del navegador), usado cuando
// el GPS del navegador falla, no responde o el usuario no concede permiso.
// No es tan preciso como el GPS (no distingue Baleares/Canarias de la
// peninsula), pero permite al menos distinguir Espana de mercado
// internacional en vez de quedarnos siempre en "WEB" por defecto. Prueba
// cada proveedor en orden hasta que uno responda correctamente.
async function resolveMarketByIP() {
  for (const provider of ipGeolocationProviders) {
    try {
      const countryCode = await provider();
      const market = marketFromCountryCode(countryCode);

      // El pais resuelto es Espana pero la IP no distingue Canarias: si el
      // huso horario del dispositivo es el de Canarias, lo forzamos en vez
      // de quedarnos en "WEB" (peninsula/Baleares) por defecto.
      if (market === "WEB" && isCanaryTimezone()) {
        return "WEB CANARIAS";
      }

      return market;
    } catch (error) {
      console.warn(
        "Geolocalizacion por IP: proveedor fallido, se prueba el siguiente:",
        error && error.message ? error.message : error
      );
    }
  }

  // Todos los proveedores han fallado.
  return null;
}

// Envuelve getCurrentPosition en una promesa para poder usar await y
// controlar el timeout (el navegador, por defecto, puede tardar
// indefinidamente si no se le da uno).
function getCurrentPositionOnce(options) {
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, reject, options);
  });
}

// Intenta resolver el mercado via GPS/geolocalizacion del navegador, un unico
// intento. Si falla (permiso denegado, timeout, error del navegador) o si
// Nominatim no responde, devuelve null de inmediato para que se use el
// fallback por IP, sin reintentar el GPS (para no alargar el tiempo hasta
// que se resuelve el mercado y se revela el grid de productos).
async function resolveMarketByGeolocation() {
  const opciones = { enableHighAccuracy: false, timeout: 8000, maximumAge: 0 };

  try {
    const position = await getCurrentPositionOnce(opciones);
    const { latitude, longitude } = position.coords;
    const data = await getProvinceFromCoordinates({ latitude, longitude });

    if (!data) {
      // Nominatim ha fallado; pasamos directamente al fallback por IP.
      return null;
    }

    return computeLocationFromProvinceData(data);
  } catch (error) {
    console.warn(
      "Geolocalizacion fallida, se usara el fallback por IP:",
      error && error.message ? error.message : error
    );
    return null;
  }
}

function applyResolvedMarket(location) {
  window.sucursalActiva = location || "WEB";
  //console.log(window.sucursalActiva);

  try {
    // Grid.setup();
    adjustVariantAvailabilityOnProductCards();
  } catch (error) {
    // nada que hacer, puede darse en cualquie otra pagina que no sea colecciones
  }

  // Recalcula el filtro nativo de Tallas (facets.js) ahora que ya
  // conocemos el mercado real, por si el listado se cargo con una talla
  // ya seleccionada (por ejemplo desde un enlace compartido) usando de
  // momento el mercado por defecto "WEB".
  if (window.applyMarketStockToGrid) window.applyMarketStockToGrid();
  if (window.updateVisibleProductCount) window.updateVisibleProductCount();

  // Avisa a facets.js de que el mercado ya esta resuelto, para que pueda
  // revelar el grid que se dejo oculto (evitar el parpadeo de productos
  // sin stock en este mercado) en cuanto sepamos el mercado real.
  window.sucursalActivaResolved = true;
  window.dispatchEvent(new Event('sucursalActivaResolved'));

  // adjustProductCard();
  adjustVariantAvailabilityOnProductCards("variant-radios");
  adjustVariantAvailabilityOnProductMobileView();

  // Con las tallas ya ajustadas al mercado, liberar el boton "Añadir" de la
  // ficha (o dejarlo en "Agotado" si no queda ninguna talla).
  try {
    updateProductAddButtons();
  } catch (error) {
    console.error("updateProductAddButtons:", error);
  }
}

document.addEventListener("DOMContentLoaded", async () => {
  //------------------ buscando la posicionb --------------------------

  let location = null;

  if (navigator.geolocation) {
    location = await resolveMarketByGeolocation();
  }

  if (!location) {
    // El GPS del navegador no esta disponible, no respondio, o el usuario
    // no ha concedido el permiso: intentamos resolver el mercado por IP en
    // vez de quedarnos silenciosamente en "WEB" para siempre.
    location = await resolveMarketByIP();
  }

  applyResolvedMarket(location);

  //--------------------------------------------------------------
});

// Suponiendo que el productId se ha definido en Liquid y la sucursal activa está en window.sucursalActiva
async function adjustProductCard() {
  var productId = window.productId;
  if (productId !== undefined) {
    var sucursalActiva = window.sucursalActiva; // Asumiendo que la sucursal activa ya está definida
    var shopName = Shopify.shop;
    // URL de tu endpoint para obtener la disponibilidad de variantes
    const apiURL = `https://api-inventory-locations.onrender.com/product-availability/${shopName}/${productId}`; // shopName lo puedes extraer desde algún lugar o definirlo

    try {
      // Hacer fetch al endpoint de disponibilidad
      const response = await fetch(apiURL);
      const data = await response.json();
      // console.log("DATA", data);
      // Verificar el stock en la sucursal activa y activar/desactivar variantes
      data.availability.forEach((variant) => {
        const inventoryInSucursal = variant.inventory.find(
          (location) => location.name === window.sucursalActiva
        );

        // Buscar la opción de variante en el DOM usando el título de la variante
        const variantOption = document.querySelector(
          `div.option-variation label[title="${variant.title}"]`
        );

        if (variantOption) {
          const input = variantOption.previousElementSibling; // El input radio correspondiente
          const optionContainer = variantOption.closest(".option-variation");

          if (
            inventoryInSucursal &&
            inventoryInSucursal.available_quantity > 0
          ) {
            // console.log("ACTIVATE", inventoryInSucursal);
            // Variante tiene stock en la sucursal activa
            activateVariant(optionContainer, input);
          } else {
            // console.log("DESACTIVATE", inventoryInSucursal);
            // Variante no tiene stock en la sucursal activa
            deactivateVariant(optionContainer, input);
          }
        }
      });
    } catch (error) {
      console.error("Error fetching product availability:", error);
    }
  }
}
//-----------------------------------------------
//ajustando la disponibilidad en los cards del listado de productos
function adjustVariantAvailabilityOnProductCards(tipo = "variant-radios-card") {
  // Definir la sucursal activa
  const sucursalActiva = window.sucursalActiva; // Ajusta este valor según tu necesidad
  // Seleccionar el elemento que contiene las variantes y su inventario
  const variantsCard = document.querySelectorAll(tipo);

  //console.log("PRUEBAS");

  if (variantsCard) {
     //console.log("variant radios", variantCard);
    variantsCard.forEach((variant) => {
      const locInventory = JSON.parse(variant.getAttribute("data-loc-inv"));
       //console.log("Check", locInventory, locInventory !== "null");
      if (locInventory != null) {
        // Seleccionar todos los inputs de tipo radio (opciones de tallas)
        const inputs = variant.querySelectorAll('input[type="radio"]');

        // Iterar sobre cada input (opción de talla)
        inputs.forEach((input) => {
          const talla = input.value;

          // Buscar la disponibilidad de esta talla en la sucursal activa
          const variantAvailability = locInventory.find(
            (inv) =>
              inv.variant_title === talla &&
              inv.location_name === sucursalActiva
          );

           //console.log(
           //  "Disponibilidad",
           //  talla,
           //  variantAvailability?.available_quantity
           //);

          // Si hay disponibilidad, habilitar la opción; si no, deshabilitarla
          if (
            variantAvailability &&
            variantAvailability.available_quantity > 0
          ) {
            input.disabled = false;
            input.classList.remove("disabled");
            const label = variant.querySelector(`label[for="${input.id}"]`);
            if (label) {
              label.classList.remove("cs-disabled");
            }
            // Ficha de producto: quitar tambien el estado agotado del
            // contenedor y su span de "Avisame".
            const optionContainer = input.closest(".option-variation");
            if (tipo === "variant-radios" && isSizeOptionContainer(optionContainer)) {
              activateVariant(optionContainer, input);
            }
          } else {
            input.disabled = true;
            input.classList.add("disabled");
            const label = variant.querySelector(`label[for="${input.id}"]`);
            if (label) {
              label.classList.add("cs-disabled");
            }
            // Ficha de producto: marcar el contenedor como agotado y crear el
            // span que abre el popup de "Avisame" (antes solo lo hacia el
            // Liquid para tallas sin stock global; las tallas sin stock solo
            // en este mercado se quedaban sin span y no abrian el popup).
            const optionContainer = input.closest(".option-variation");
            if (tipo === "variant-radios" && isSizeOptionContainer(optionContainer)) {
              deactivateVariant(optionContainer, input);
            }
          }
        });
      }
    });
  }
}

//ajustando la disponibilidad en el dialog mobile
function adjustVariantAvailabilityOnProductMobileView(

  tipo = ".variant-selector"
) {
  // Definir la sucursal activa
  const sucursalActiva = window.sucursalActiva; // Ajusta este valor según tu necesidad

  // Seleccionar el elemento que contiene las variantes y su inventario
  const variantsCard = document.querySelectorAll(tipo);

  //console.log(variantsCard);

  if (variantsCard) {
    // console.log("variant radios", variantCard);

    variantsCard.forEach((variant) => {
      const locInventory = JSON.parse(variant.getAttribute("data-loc-inv"));

      if (locInventory != null) {
        // Seleccionar todos los inputs de tipo radio (opciones de tallas)
        const inputs = variant.querySelectorAll("input.product-variant-id");

        // Iterar sobre cada input (opción de talla)
        inputs.forEach((input) => {
          const talla = input.getAttribute("data-title");

          // Buscar la disponibilidad de esta talla en la sucursal activa
          const variantAvailability = locInventory.find(
            (inv) =>
              inv.variant_title === talla &&
              inv.location_name === sucursalActiva
          );

          // console.log(
          //   "Dispo-Mobile",
          //   talla,
          //   variantAvailability?.available_quantity
          // );
          const htmlBlock = `
          <span style="cursor: pointer" onclick="javascript:openPopUpOutOfStock(this)" class="text-notifyme-wrapper">
            <span class="text-notifyme">AVÍSAME CUANDO ESTÉ DISPONIBLE</span>
          </span>
        `;
          // Si hay disponibilidad, habilitar la opción; si no, deshabilitarla
          const btn = input.closest("form").querySelector("button");
          const notifyElement = input
            .closest("form")
            .querySelector(".text-notifyme-wrapper");
          if (
            variantAvailability &&
            variantAvailability.available_quantity > 0
          ) {
            // Verifica si el botón está habilitado (no tiene el atributo disabled)
            btn.classList.remove("geo-disabled");

            if (!btn.disabled && notifyElement) {
              notifyElement.remove(); // Elimina el bloque de notificación si el botón está habilitado
              // OJO: setAttribute("disabled", false) desactivaba el boton
              // (cualquier valor del atributo lo desactiva). Lo quitamos.
              btn.removeAttribute("disabled");
            }else{
              const validateNotify = btn.querySelector('span.text-notifyme-wrapper');
              if(validateNotify) validateNotify.remove();
            }
          } else {
            btn.classList.add("geo-disabled");
            btn.setAttribute("disabled", true);
            btn.removeAttribute("onclick");

            if (!notifyElement) {
              btn.insertAdjacentHTML("afterend", htmlBlock);
            }
          }
        });
      }
    });
  }
}

//mutation
document.addEventListener("DOMContentLoaded", async () => {
  const handleProductSlideInventoryAvailable = (node = document) => {
    //console.log("NODE", node);
  };
  // Configurar el MutationObserver
  const observerProductSlide = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            handleProductSlideInventoryAvailable(node);
          }
        });
      }
    });
  });

  // Iniciar la observación si productRelated existe
  const targetSlide = document.querySelector("slider-component");
  if (targetSlide)
    observerProductSlide.observe(targetSlide, {
      childList: true,
      subtree: true,
    });
});